import {
  Button,
  Heading,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  InputRightElement,
  Stack,
  HStack,
  Tag,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import React, { useState } from "react";
import { ImBackward, ImForward2 } from "react-icons/im";
import { createInterests, loginUser } from "./service";
import { errorNotifier } from "../..";
import { useGetState } from "../../context/useGetState";
import axios from "axios";
import image from "../../assets/image.jpeg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import splash from "../../assets/splash.jpg";

// Function to generate a slug from text
const slugify = (text) => {
  return text.toLowerCase().replace(/ /g, "-");
};

const InterestScreen = ({ next, prev, totalStep }) => {
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [loading, setLoading] = useState(false);
  const { dispatch } = useGetState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [show, setShow] = useState(false);

  const handleInterestClick = (interest) => {
    const slug = slugify(interest);
    // Check if the interest is already in the selected interests array
    if (selectedInterests.includes(slug)) {
      // If it exists, remove it from the array
      setSelectedInterests((prevInterests) =>
        prevInterests.filter((item) => item !== slug)
      );
    } else {
      // If it doesn't exist, add it to the array
      setSelectedInterests((prevInterests) => [...prevInterests, slug]);
    }
  };

  //handle login automatically
  const storeUserDetails = (details) => {
    dispatch({ userInfo: details });
    sessionStorage.setItem("acc_type", details?.occupation);
    sessionStorage.setItem("#f8WEB#", details?.token);
    sessionStorage.setItem("#f8WEB-firebase-success#", true);
  };

  const email = sessionStorage.getItem("email");
  const password = sessionStorage.getItem("password");

  // Get the bearer token from sessionStorage
  const token = sessionStorage.getItem("#f8WEB#");

  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  //const createInterestsUrl = "https://f8.codester.dev/web/api/user-details3";
  const createInterestsUrl = "https://f8.codester.dev/api/user-details3";
  //const loginUrl = "https://f8.codester.dev/web/api/login";
  const loginUrl = "https://f8.codester.dev/api/login";

  const submitAndLogin = async (email, password, setLoading) => {
    const payload = {
      interest: selectedInterests,
    };

    try {
      // Make the Axios call with headers
      const response = await axios.post(createInterestsUrl, payload, {
        headers,
      });

      // ... Further processing of response
    } catch (error) {
      console.error(error);
    }

    console.log("dwn");

    //login
    setLoading(true);

    const credentials = {
      login: email,
      password,
    };

    try {
      // Make the Axios call with headers
      const response = await axios.post(loginUrl, credentials);
      const details = response?.data;
      storeUserDetails(details);
      setLoading(false);
      window.location.href = "/";

      // ... Further processing of response
    } catch (error) {
      console.error(error);
    }
  };

  const handleClick = () => {
    console.log("here");
  };
  const handlePrev = () => {
    prev();
    sessionStorage.setItem("totalStep", "InterestScreen");
  };

  const stage = sessionStorage.getItem("totalStep");

  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid>
        <Box
          my={"11"}
          backgroundColor={"#020B19"}
          mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          mt={{
            base: "2em",
            sm: "2em",
            md: "2em",
            lg: "2em",
            xl: "2em",
            "2xl": "2em",
          }}
          h={{
            base: "90vh",
            sm: "85vh",
            md: "90vh",
            lg: "88vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "25px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            mt={{
              base: "-1em",
              sm: "-2.0em",
              md: "-2.5em",
              lg: "-2.5em",
              xl: "-1em",
              "2xl": "2em",
            }}
          >
            <Flex
              p={"2%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack w={"full"} maxW={"md"}>
                <Box mt={8}>
                  <Link to={"/register/info"}>
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      cursor={"pointer"}
                      src={arrow}
                    />
                  </Link>

                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    Pick your Interests
                  </Heading>
                  <Text
                    fontWeight={400}
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    color={"white"}
                    fontSize={"15px"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    This will help us recommend better content and match you
                    with people with same interest as you
                  </Text>
                </Box>

                <Grid
                  h={"200px"}
                  overflowY={"scroll"}
                  sx={{
                    "::-webkit-scrollbar": {
                      display: "auto",
                      w: 1,
                    },
                    "&::-webkit-scrollbar-track": {
                      w: "2",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      borderRadius: "10",
                      bg: `gray.100`,
                    },
                  }}
                  templateColumns="repeat(2, 1fr)"
                  gap={2}
                >
                  {[
                    { lg: "lg", name: "Finance" },
                    { lg: "lg", name: "Education" },
                    { lg: "lg", name: "Influencer" },
                    { lg: "lg", name: "Real Estate" },
                    { lg: "lg", name: "Investor" },
                    { lg: "lg", name: "Technology" },
                    { lg: "lg", name: "Religion" },
                    { lg: "lg", name: "Gaming" },
                    { lg: "lg", name: "Sports" },
                  ].map((size) => (
                    <Box
                      w="100%"
                      h="10"
                      onClick={() => handleInterestClick(size?.name)}
                      textAlign={"center"}
                      cursor={"pointer"}
                    >
                      <Tag
                        size={size.lg}
                        key={size.lg}
                        px={6}
                        py={3}
                        justifyContent={"center"}
                        alignItems={"center"}
                        fontSize={"14px"}
                        color={"white"}
                        borderRadius={34}
                        variant={
                          selectedInterests.includes(slugify(size?.name))
                            ? "solid"
                            : "outline"
                        }
                        colorScheme="teal"
                        onClick={handleClick(size.name)}
                        _hover={{
                          bg: "blue.600",
                        }}
                      >
                        {size.name}
                      </Tag>
                    </Box>
                  ))}
                </Grid>

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>
                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      type="submit"
                      h={"50px"}
                      variant={"solid"}
                      _hover={{ background: "#7182f5" }}
                      disabled={selectedInterests.length === 0} // Disable the button when no interests are selected
                      onClick={() => {
                        submitAndLogin(email, password, setLoading);
                      }}
                    >
                      {loading ? <Spinner /> : "Continue"}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Flex>
            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select
              fontFamily={("Poppins-Regular", "Helvetica")}
              fontSize={".9em"}
              color={"white"}
              w="auto"
            >
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Grid>
    </Center>
  );
};

export default InterestScreen;
